import { render, staticRenderFns } from "./Retaguarda.vue?vue&type=template&id=02a8d708&"
import script from "./Retaguarda.vue?vue&type=script&lang=js&"
export * from "./Retaguarda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports